import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WebStorage } from "./web-storage";
@Injectable({
  providedIn: "root",
})
export class DocumentLanguagesStorageService {
  private storage = inject(WebStorage);
  primaryDocumentLanguagesStorageSubject = new BehaviorSubject<Record<
    string,
    string[]
  > | null>(this.storage.primaryDocumentLanguagesStored);
  primaryDocumentLanguages$ =
    this.primaryDocumentLanguagesStorageSubject.asObservable();

  secondaryDocumentLanguagesStorageSubject = new BehaviorSubject<Record<
    string,
    string[]
  > | null>(this.storage.secondaryDocumentLanguagesStored);
  secondaryDocumentLanguages$ =
    this.secondaryDocumentLanguagesStorageSubject.asObservable();

  setPrimaryDocumentLanguages(documentLanguages: Record<string, string[]>) {
    this.storage.primaryDocumentLanguagesStored = documentLanguages;
    this.primaryDocumentLanguagesStorageSubject.next(
      this.storage.primaryDocumentLanguagesStored,
    );
  }

  setSecondaryDocumentLanguages(documentLanguages: Record<string, string[]>) {
    this.storage.secondaryDocumentLanguagesStored = documentLanguages;
    this.secondaryDocumentLanguagesStorageSubject.next(
      this.storage.secondaryDocumentLanguagesStored,
    );
  }
}
